<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [title]="'admin.pos.grid.title'|translate">
        <app-grid [grid]="grid" (sendParameters)="setParams($event)"></app-grid>
      </app-card>
    </div>
  </div>
</div>
